export enum FilterComponent {
    MultiSelectTree,
    SingleSelectTree,
    ComboBox
}